export var Types;
(function (Types) {
    Types["UPDATE_ERROR"] = "UPDATE_ERROR";
    Types["UPDATE_CHAT_ENABLED"] = "UPDATE_CHAT_ENABLED";
    Types["LOADING"] = "LOADING";
    Types["START_BOT_TYPING"] = "START_BOT_TYPING";
    Types["STOP_BOT_TYPING"] = "STOP_BOT_TYPING";
})(Types || (Types = {}));
//# sourceMappingURL=OtherActions.js.map